<template>
<div>

    <vm-card list :header="__('company')" >
        <vm-row>

            <vm-group c6>
                <vm-label :text="__('company_name')" />
                <vm-input v-model="value.name" maxbo bold disabled :invalid="!checks.name" />
            </vm-group>
            <vm-group c3>
                <vm-label :text="__('org_number')" />
                <vm-input v-model="value.orgnr" maxbo bold disabled :invalid="!checks.orgnr" />
            </vm-group>
            <vm-group c3>
                <vm-label :text="__('customer_number')" />
                <vm-input v-model="value.number" maxbo bold disabled :invalid="!checks.number" />
            </vm-group>

            <vm-group c6>
                <vm-label :text="__('business')" />
                <vm-input v-model="value.business" maxbo bold disabled :invalid="!checks.business" />
            </vm-group>
            <vm-group c3>
                <vm-label :text="__('customer_type')" />
                <vm-input v-model="value.category" maxbo bold disabled :invalid="!checks.category" />
            </vm-group>
            <vm-group c3>
                <vm-label :text="__('department_id')" />
                <vm-input v-model="value.warehouseId" maxbo bold disabled :invalid="!checks.warehouseId" />
            </vm-group>

            <vm-group c6>
                <vm-label :text="__('address')" />
                <vm-input v-model="value.postAddress.street" maxbo bold disabled :invalid="!checks.postAddress.street" />
            </vm-group>
            <vm-group c2>
                <vm-label :text="__('zip_code')" />
                <vm-input v-model="value.postAddress.zip" maxbo bold disabled :invalid="!checks.postAddress.zip" />
            </vm-group>
            <vm-group c4>
                <vm-label :text="__('city')" />
                <vm-input v-model="value.postAddress.city" maxbo bold disabled :invalid="!checks.postAddress.city" />
            </vm-group>

        </vm-row>
    </vm-card>

    <vm-card list :header="__('contacts')" >

        <vm-row>
            <vm-group c5>
                <vm-label :text="__('contact_customer')" />
                <vm-input v-model="value.contact.name" maxbo bold disabled :invalid="!checks.contact.name" />
            </vm-group>
            <vm-group c3>
                <vm-label :text="__('phone')" />
                <vm-input v-model="value.contact.phone" maxbo bold disabled :invalid="!checks.contact.phone" />
            </vm-group>
            <vm-group c4>
                <vm-label :text="__('email')" />
                <vm-input v-model="value.contact.email" maxbo bold disabled :invalid="!checks.contact.email" />
            </vm-group>
        </vm-row>

        <vm-row>
            <vm-group c5>
                <vm-label :text="__('contact_maxbo')" />
                <vm-input v-model="value.associate.name" maxbo bold disabled :invalid="!checks.associate.name" />
            </vm-group>
            <vm-group c3>
                <vm-label :text="__('phone')" />
                <vm-input v-model="value.associate.phone" maxbo bold disabled :invalid="!checks.associate.phone" />
            </vm-group>
            <vm-group c4>
                <vm-label :text="__('email')" />
                <vm-input v-model="value.associate.email" maxbo bold disabled :invalid="!checks.associate.email" />
            </vm-group>
        </vm-row>

        <vm-row v-if="!value.editorIsOwner">
            <vm-group c5>
                <vm-label :text="__('contact_editor')" />
                <vm-input v-model="value.editor.name" maxbo bold disabled :invalid="!checks.editor.name" />
            </vm-group>
            <vm-group c3>
                <vm-label :text="__('phone')" />
                <vm-input v-model="value.editor.phone" maxbo bold disabled :invalid="!checks.editor.phone" />
            </vm-group>
            <vm-group c4>
                <vm-label :text="__('email')" />
                <vm-input v-model="value.editor.email" maxbo bold disabled :invalid="!checks.editor.email" />
            </vm-group>
        </vm-row>

    </vm-card>

    <vm-card list :header="__('economy')" >

        <vm-row>
            <vm-group c6>
                <vm-label :text="__('deposits_expected')" />
                <vm-input v-model="value.economy.depositsExpected" maxbo bold disabled :invalid="!checks.economy.depositsExpected" />
            </vm-group>
            <vm-group c6>
                <vm-label :text="__('credit_limit')" />
                <vm-input v-model="value.economy.creditLimit" maxbo bold disabled :invalid="!checks.economy.creditLimit" />
            </vm-group>
        </vm-row>

    </vm-card>

</div>
</template>
<script>

export default {
name: 'Customer',
props: {
    value: {
        type: Object,
        default: null
    }
},
data() {
    return {
        checks: {
            name: false,
            orgnr: false,
            number: false,
            business: false,
            category: false,
            warehouseId: false,
            postAddress: {
                street: false,
                zip: false,
                city: false
            },
            contact: {
                name: false,
                phone: false,
                email: false
            },
            associate: {
                name: false,
                phone: false,
                email: false
            },
            editor: {
                name: false,
                phone: false,
                email: false
            },
            economy: {
                depositsExpected: false,
                creditLimit: false
            }
        }
    }
},
methods: {
    emptyString(value) {
        return !value || value.length === 0;
    },
	isFullName(value) {
		return !!value && value.split(' ').length > 1;
	},
    notZero(value) {
        return value && value.length > 0 || Number(value) > 0;
    }
},
mounted() {
    const result = {
        valid: true
    };
    
    this.checks.name = this.isFullName(this.value.name);
    this.checks.orgnr = !this.emptyString(this.value.orgnr);
    this.checks.number = !this.emptyString(this.value.number);
    this.checks.business = !this.emptyString(this.value.business);
    this.checks.category = this.value.category.toLowerCase() === 'kunde';
    this.checks.warehouseId = !this.emptyString(this.value.warehouseId);

    this.checks.postAddress.street = !this.emptyString(this.value.postAddress.street);
    this.checks.postAddress.zip = !this.emptyString(this.value.postAddress.zip);
    this.checks.postAddress.city = !this.emptyString(this.value.postAddress.city);

    this.checks.contact.name = this.isFullName(this.value.contact.name);
    this.checks.contact.phone = !this.emptyString(this.value.contact.phone);
    this.checks.contact.email = !this.emptyString(this.value.contact.email);

    this.checks.associate.name = this.isFullName(this.value.associate.name);
    this.checks.associate.phone = !this.emptyString(this.value.associate.phone);
    this.checks.associate.email = !this.emptyString(this.value.associate.email);

    this.checks.editor.name = this.isFullName(this.value.editor.name);
    this.checks.editor.phone = !this.emptyString(this.value.editor.phone);
    this.checks.editor.email = !this.emptyString(this.value.editor.email);

    this.checks.economy.depositsExpected = !this.emptyString(this.value.economy.depositsExpected);
    this.checks.economy.creditLimit = this.notZero(this.value.economy.creditLimit);


    for (let i in this.checks) {
        if (typeof this.checks[i] == 'object') {
            for (let j in this.checks[i]) {
                if (!this.checks[i][j]) result.valid = false;
            }
        }else {
            if (!this.checks[i]) result.valid = false;
        }
    }

    this.$emit('validated', result);
}
}
</script>
<style scoped>

</style>
